import { Box, Button, Checkbox, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import { useState } from "react";
import { EmailOutlined, FmdGoodOutlined, KeyboardArrowDown, KeyboardArrowUp, LocalPhoneOutlined } from "@mui/icons-material";
import styles from "../add.module.css";
import dayjs from "dayjs";

const WHItemListCustomRow = ({ item, addToContainer, addToContainer2, isItemSelected, selectRowEvent }) => {
    const [open, setOpen] = useState(false);

    return <>
        <StyledMainTableRow sx={{ "& > *": { borderBottom: "unset" } }} onClick={(e) => selectRowEvent(item?.id)} aria-checked={isItemSelected} selected={isItemSelected}>
            <TableCell padding="checkbox" style={{ width: '15px', paddingLeft: '0' }}>
                <Checkbox color="primary" checked={isItemSelected} />
            </TableCell>
            <TableCell component="th" scope="row" style={{ paddingLeft: '2px', paddingRight: '2px' }}>
                <IconButton aria-label="expand row" size="small" onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
                    {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
                {item?.booking_id}
            </TableCell>
            <TableCell component="th" scope="row" style={{ paddingLeft: '2px', paddingRight: '2px' }}>{dayjs(item?.pickup_date).format("DD/MM/YYYY")}</TableCell>
            <TableCell component="th" className={`${styles.TableColumn1}`} scope="row" style={{ width: '15px', padding: '0', textAlign: 'center' }}>{item?.no_of_item}</TableCell>
            <TableCell component="th" className={`${styles.TableColumn2}`} scope="row" style={{ width: '15px', padding: '0', textAlign: 'center' }}>{item?.no_of_item}</TableCell>
            <TableCell component="th" className={`${styles.TableColumn2}`} scope="row" style={{ width: '15px', padding: '0', textAlign: 'center' }}>{item?.no_of_item3}</TableCell>
            <TableCell component="th" className={`${styles.TableColumn2}`} scope="row" style={{ width: '15px', padding: '0', textAlign: 'center' }}>{item?.no_of_item2}</TableCell>
            <TableCell component="th" scope="row">
                <Button className={`${styles.StatusBU}`} onClick={(e) => { e.stopPropagation(); addToContainer(item); }}>Add All</Button>
            </TableCell>
        </StyledMainTableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <div className={`${styles.ExpandedDiv}`}>
                            <div className={`${styles.ExpandedDivHalf} ${styles.ExpandedDivHalf1}`}>
                                <p>Pickup Address</p>
                                <p className={`${styles.PickName}`}>{item?.pickup_details?.name}</p>
                                <p className={`${styles.DetailsList}`}><FmdGoodOutlined />{item?.pickup_details?.address}</p>
                                <p className={`${styles.DetailsList}`}><EmailOutlined />{item?.pickup_details?.email}</p>
                                <p className={`${styles.DetailsList}`}><LocalPhoneOutlined />{item?.pickup_details?.phone}</p>
                            </div>
                            <div className={`${styles.ExpandedDivHalf} ${styles.ExpandedDivHalf2}`} style={{ float: "left" }}>
                                <p>Delivery Address</p>
                                <p className={`${styles.PickName}`}>{item?.recipient_details?.name}</p>
                                <p className={`${styles.DetailsList}`}><FmdGoodOutlined />{item?.recipient_details?.address}</p>
                                {item?.recipient_details?.email !== '' && <p className={`${styles.DetailsList}`}><EmailOutlined />{item?.recipient_details?.email}</p>}
                                <p className={`${styles.DetailsList}`}><LocalPhoneOutlined />{item?.recipient_details?.phone}</p>
                            </div>
                        </div>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <StyledMainTableCell>Product Id</StyledMainTableCell>
                                    <StyledMainTableCell align="left">ITEM</StyledMainTableCell>
                                    <StyledMainTableCell align="left">Status</StyledMainTableCell>
                                    <StyledMainTableCell align="left"></StyledMainTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item?.products.map((row) => (<TableRow key={row?.id}>
                                    <TableCell component="th" scope="row">{row?.item_id}</TableCell>
                                    <TableCell>{row?.product_title}</TableCell>
                                    <TableCell align="right">{row?.status_text}</TableCell>
                                    <TableCell align="right">{row?.is_wh_received === 1 && row?.is_container_loaded === 0 ? (<Button className={`${styles.StatusBU}`} onClick={(e) => { addToContainer2(row); }}>Add</Button>) : null}</TableCell>
                                </TableRow>))}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </>
}

export default WHItemListCustomRow;